export interface Objekt {
  id: string;
  objekt: string;
  bezeichnung: string;
  archiveKey?: string;
  geodaten?: {
    gpsbreite: number | null;
    gpslaenge: number | null;
  };
}
